import { StatsCard } from '@/components/Custom/Card/StatsCard';
import { twMerge } from 'tailwind-merge';

interface ActivityCardProps {
  title: string;
  description: string;
  number: number;
  containerClassName?: string;
  titleClassName?: string;
  numberClassName?: string;
}

export const ActivityCard = ({
  title,
  description,
  number,
  containerClassName,
  titleClassName,
  numberClassName,
}: ActivityCardProps) => {
  return (
    <StatsCard
      containerClassName={twMerge(
        'shadow-none min-w-[210px] min-3xl:min-w-[230px]',
        containerClassName
      )}
      titleClassName={twMerge('font-medium', titleClassName)}
      numberClassName={twMerge('mt-2.25', numberClassName)}
      title={title}
      description={description}
      number={number}
    />
  );
};
